<script setup lang="ts">
import { onBeforeMount, onBeforeUnmount, ref } from "vue"

import { useEnvVar } from "@/composables/useEnvVar"

const stage = useEnvVar("VITE_STAGE")
const version = useEnvVar("BUILD_VERSION")
const branch = useEnvVar("BUILD_BRANCH")
const commit = useEnvVar("LAST_COMMIT")

const hidden = ref(true)

const onKeydown = (e: KeyboardEvent) => {
  if (e.code === "KeyV") togglePane()
}

const togglePane = () => {
  hidden.value = !hidden.value
}

onBeforeMount(() => {
  window.addEventListener("keydown", onKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener("keydown", onKeydown)
})
</script>

<template>
  <div
    :class="['version-panel', { hidden }]"
    v-if="stage !== 'production'"
  >
    <h2>Version Panel</h2>
    <table>
      <tbody>
        <tr>
          <td>Environment:</td>
          <td>{{ stage }}</td>
        </tr>
        <tr>
          <td>Version:</td>
          <td>{{ version }}</td>
        </tr>
        <tr>
          <td>Branch:</td>
          <td>{{ branch }}</td>
        </tr>
        <tr>
          <td>Commit:</td>
          <td>{{ commit }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.version-panel {
  padding: 1rem;
  position: fixed;
  bottom: 0;
  right: 0;

  z-index: 1000000;
  font-family: monospace;
  font-size: 1.2rem;
  max-width: 400px;
  background: rgba(0, 0, 0, 0.85);

  &.hidden {
    display: none;
  }

  & h2 {
    background: rgba(0, 0, 0, 0.4);
    color: white;
    display: flex;
    padding: 10px;
    margin: 2px;
    margin-bottom: 0;
    font-size: 1.4rem;
  }

  & td {
    padding: 10px;
    background: rgba(0, 0, 0, 0.4);
    color: white;
    margin: 0;
  }
}
</style>
